import React, { useState } from 'react'
import './verifyOTP.css'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService"
import { updateUserDetails } from "../../redux/userData/index";
import { useDispatch } from 'react-redux';
import Logo from '../../assets/image.png'

const VerifyOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const token = new URLSearchParams(window.location.search).get('token');

  const email = location.state?.email;
  const resetPassword = location.state?.resetPassword;
  const tokenSecret = location.state?.secret

  const [secret, setSecret] = useState(tokenSecret);
  const [otp, setOTP] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmpasswordVisible, setConfirmPasswordVisible] = useState(false);

  const togglePasswordVisibile = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibile = () => {
    setConfirmPasswordVisible(!confirmpasswordVisible);
  };


  const handleResendOTP = async (e) => {
    e.preventDefault();
    try {
      const response = await apiServiceHandler("POST", "api/auth/resend/otp", { email });
      // console.log('Data is here...', response);
      if (response.auth) {
        toastr.success("OTP Resent successfully.")
        setSecret(response.secret)
      } else {
        toastr.error(response.message || "Failed to Resend OTP. Please try again.")
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error(error.response);
    }
  }

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    const payload = {};
    try {
      let response = '';
      if (resetPassword || token) {
        if (password != confirmPassword) {
          throw new Error('Password and Confirm Password must be same')
        }
        payload.otp = otp;
        payload.secret = token ? token : secret;
        payload.password = password;
        response = await apiServiceHandler("POST", "api/auth/forgot/verifyotp", { ...payload });
        console.log('verifyotp Data is here...', response);
      } else {
        payload.otp = otp;
        payload.secret = secret;
        response = await apiServiceHandler("POST", "api/auth/verify/otp", { ...payload });
        console.log('otp Data is here...', response);
      }
      if (response?.auth) {
        toastr.success("OTP Verified Successfully")
        const token = response.token.split(' ')[1];
        localStorage.setItem("STG_TOKEN", token);
        localStorage.setItem("userDetails", JSON.stringify(response.user));
        localStorage.setItem("userId", JSON.stringify(response.user._id));
        dispatch(updateUserDetails(response.user));
        const hasOtherKeyWithValueOne = Object.entries(response?.user?.courses_access).some(([key, value]) => key !== 'stg90' && value === 1);
        if (hasOtherKeyWithValueOne) {
          navigate('/courses')
        } else {
          navigate("/welcome-to-stg");
        }
        
      } else {
        toastr.error(response.message || "Failed to Verify OTP. Please try again.")
      }
    } catch (error) {
      toastr.error(error?.message || error.response.data.message);
      console.error(error || error.response);
    }
  };

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="auth-view__container">
            <div className="auth-logo">
              <img src={Logo} />
            </div>
            <div className="reset-view">
              <div className="reset-heading">VERIFY OTP</div>
              <form className='otp-form' onSubmit={handleVerifyOTP}>
                {(resetPassword || token) && <div>
                  <div className="signup-view__field">
                    <div className="signup-view__field-input" name="password">
                      <div className="text-input_input-wrapper">
                        <input
                          type={passwordVisible ? "text" : "password"}
                          className="auth-text-input__input"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                        <span className="icon-eye" onClick={togglePasswordVisibile}>
                          {!passwordVisible ? (
                            <svg
                              viewBox="0 0 24 15"
                              fill="#d1b794"
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon__svg"
                              preserveAspectRatio="xMidYMid meet"
                              style={{ width: "20px", height: "20px" }}
                            >
                              <path d="M11.993.5C6.333.5 1.346 4.423.023 9.563a.75.75 0 001.453.374C2.616 5.507 7.033 2 11.993 2c4.96 0 9.39 3.508 10.53 7.937a.75.75 0 001.453-.374C22.653 4.422 17.653.5 11.993.5zm.008 4a4.843 4.843 0 00-4.832 4.832A4.844 4.844 0 0012 14.165a4.845 4.845 0 004.833-4.833A4.844 4.844 0 0012 4.5z"></path>
                            </svg>
                          ) : (
                            <svg
                              viewBox="0 0 24 22"
                              fill="#d1b794"
                              xmlns="http://www.w3.org/2000/svg"
                              class="icon__svg"
                              preserveAspectRatio="xMidYMid meet"
                              style={{ width: "20px", height: "20px" }}
                            >
                              <path d="M21.235.993a.75.75 0 00-.515.227l-6.707 6.707-.007-.004-6.583 6.582.004.008L2.22 19.72a.75.75 0 101.06 1.06l4.977-4.976A4.98 4.98 0 0012 17.5c2.757 0 5-2.243 5-5 0-1.49-.658-2.827-1.696-3.743l2.222-2.223c2.426 1.42 4.308 3.714 5 6.4a.747.747 0 00.909.54.74.74 0 00.54-.909c-.77-3-2.744-5.528-5.336-7.143L21.78 2.28a.75.75 0 00-.545-1.287zM11.995 3.5C6.41 3.5 1.375 7.31.025 12.565a.74.74 0 00.54.91.74.74 0 00.91-.54C2.64 8.41 7.165 5 11.995 5c.855 0 1.7.105 2.515.31l1.23-1.23a12.346 12.346 0 00-3.745-.58zm.005 4c-2.757 0-5 2.243-5 5 0 .098.009.195.015.293l5.278-5.278c-.098-.006-.194-.015-.293-.015zm.816 3.744a1.5 1.5 0 11-2.072 2.072l2.072-2.072z"></path>
                            </svg>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="signup-view__field">
                    <div className="signup-view__field-input" name="password">
                      <div className="text-input_input-wrapper">
                        <input
                          type={confirmpasswordVisible ? "text" : "password"}
                          className="auth-text-input__input"
                          placeholder="Confirm your password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                        <span className="icon-eye" onClick={toggleConfirmPasswordVisibile}>
                          {!confirmpasswordVisible ? (
                            <svg
                              viewBox="0 0 24 15"
                              fill="#d1b794"
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon__svg"
                              preserveAspectRatio="xMidYMid meet"
                              style={{ width: "20px", height: "20px" }}
                            >
                              <path d="M11.993.5C6.333.5 1.346 4.423.023 9.563a.75.75 0 001.453.374C2.616 5.507 7.033 2 11.993 2c4.96 0 9.39 3.508 10.53 7.937a.75.75 0 001.453-.374C22.653 4.422 17.653.5 11.993.5zm.008 4a4.843 4.843 0 00-4.832 4.832A4.844 4.844 0 0012 14.165a4.845 4.845 0 004.833-4.833A4.844 4.844 0 0012 4.5z"></path>
                            </svg>
                          ) : (
                            <svg
                              viewBox="0 0 24 22"
                              fill="#d1b794"
                              xmlns="http://www.w3.org/2000/svg"
                              class="icon__svg"
                              preserveAspectRatio="xMidYMid meet"
                              style={{ width: "20px", height: "20px" }}
                            >
                              <path d="M21.235.993a.75.75 0 00-.515.227l-6.707 6.707-.007-.004-6.583 6.582.004.008L2.22 19.72a.75.75 0 101.06 1.06l4.977-4.976A4.98 4.98 0 0012 17.5c2.757 0 5-2.243 5-5 0-1.49-.658-2.827-1.696-3.743l2.222-2.223c2.426 1.42 4.308 3.714 5 6.4a.747.747 0 00.909.54.74.74 0 00.54-.909c-.77-3-2.744-5.528-5.336-7.143L21.78 2.28a.75.75 0 00-.545-1.287zM11.995 3.5C6.41 3.5 1.375 7.31.025 12.565a.74.74 0 00.54.91.74.74 0 00.91-.54C2.64 8.41 7.165 5 11.995 5c.855 0 1.7.105 2.515.31l1.23-1.23a12.346 12.346 0 00-3.745-.58zm.005 4c-2.757 0-5 2.243-5 5 0 .098.009.195.015.293l5.278-5.278c-.098-.006-.194-.015-.293-.015zm.816 3.744a1.5 1.5 0 11-2.072 2.072l2.072-2.072z"></path>
                            </svg>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>}
                <div className="verify-otp__field">
                  <div className="reset-view__field-input" name="email">
                    <div className="text-input_input-wrapper">
                      <input
                        type="text"
                        className="auth-text-input__input"
                        placeholder="Enter the OTP"
                        value={otp}
                        onChange={(e) => setOTP(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <button type='submit' className="verify-otp-btn reset-button__label">
                  VERIFY OTP
                </button>
              </form>
              <div className="reset-view__footer">
                {!token && <div style={{ display: "flex", gap: "0.1rem" }}>
                  <span style={{color: '#fff'}}>Didn't receive OTP? </span>
                  <button onClick={handleResendOTP} className="resend-otp">
                    Resend
                  </button>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default VerifyOTP